import AnimatedPosition from './animated_position'

export default AnimatedPosition
